import React from "react";
import { Modal, Button } from "antd";

const DeleteModalCategory = ({
  deleteModalVisible,
  setDeleteModalVisible,
  handleDelete,
  section,
  selectedItem,
}) => {
  return (
    <Modal
      title="Delete Confirmation"
      open={deleteModalVisible}
      centered
      onCancel={() => setDeleteModalVisible(false)}
      footer={[
        <Button key="cancel" onClick={() => setDeleteModalVisible(false)}>
          Cancel
        </Button>,
        <Button
          key="delete"
          type="primary"
          danger
          onClick={() => {
            handleDelete(section, selectedItem.id);
          }}
        >
          Delete
        </Button>,
      ]}
    >
      <p>
        Are you sure you want to delete the {section}{" "}
        <strong>{selectedItem?.name}</strong>?
      </p>
    </Modal>
  );
};

export default DeleteModalCategory;
